module.exports = __webpack_public_path__ + "img/maneken_back.726e67dc.png";